import { render, staticRenderFns } from "./GiaNia.vue?vue&type=template&id=13212614&"
import script from "./GiaNia.vue?vue&type=script&lang=ts&"
export * from "./GiaNia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports